export default function getImageFromLookup(imageLookup, url) {
    if (imageLookup === void 0) { imageLookup = {}; }
    if (!url) {
        return '';
    }
    return imageLookup[url] || {
        hashedURL: url
    };
}
